export default __webpack_public_path__ + "static/media/logo_only_team_phddi.ca523d69.png";